module.exports = __webpack_public_path__ + "static/media/worker.e702d57e.svg";